import React from 'react';

import { InfoIcon } from '../icons/info-icon';

import { BannerContainer, BannerCopy } from './banner.styles';

type BannerProps = {
  copy: React.ReactNode;
  icon?: JSX.Element;
};

export function InfoBanner({ copy, icon }: BannerProps) {
  return (
    <BannerContainer>
      {icon || <InfoIcon />}
      <BannerCopy>{copy}</BannerCopy>
    </BannerContainer>
  );
}
